/**
 * Labstep
 *
 * @module components/Folder/Action/Remove/Bulk
 * @desc Action to remove parentEntity to folder
 */

import { useHasAccessMultiple } from 'labstep-web/components/Entity/Can/hooks';
import { Action } from 'labstep-web/components/Entity/Can/types';
import { FolderActionRemove } from 'labstep-web/components/Folder/Action/Remove';
import { ActionComponentBulk as BulkActionComponent } from 'labstep-web/core/Action/Component/Bulk';
import { Folder } from 'labstep-web/models/folder.model';
import type React from 'react';
import type { FolderActionRemoveBulkProps } from './types';

export const FolderActionRemoveBulk: React.FC<
  FolderActionRemoveBulkProps
> = ({ entityName, parentEntities, options = {} }) => {
  const parentEntityIdsAccessObject = useHasAccessMultiple(
    entityName,
    parentEntities.map((e) => e.id),
    `folder_${entityName}:${Action.add_remove}` as Action,
  );

  if (parentEntities.length === 0) {
    return null;
  }

  const parentEntitiesWithPermission = parentEntities.filter(
    (e) => parentEntityIdsAccessObject[e.id],
  );

  return (
    <FolderActionRemove
      parentName={entityName}
      parentId={parentEntitiesWithPermission.map((p) => p.id)}
      onSuccess={options.onSuccess}
      actionComponentProps={{
        type: 'children',
        children: ({ onClick, status }) => (
          <BulkActionComponent
            entitiesWithPermissionCount={
              parentEntitiesWithPermission.length
            }
            entitiesSelectedCount={parentEntities.length}
            disabled={(status && status.isFetching) || false}
            onClick={onClick}
            content={`Remove from ${Folder.getHumanReadableEntityName()}`}
            icon="remove"
          />
        ),
      }}
    />
  );
};
